import React, { Fragment } from "react";
import { Checkbox, Typography, Box } from "@material-ui/core";

const Check = ({ values, handleChange, label, name, ...props }) => {
  return (
    <Fragment>
      <Box alignItems="center" display="flex" ml={-1}>
        <Checkbox
          checked={values[name]}
          name={name}
          onChange={handleChange}
          {...props}
        />
        <Typography color="textSecondary" variant="body1">
          {label}
        </Typography>
      </Box>
      {Boolean(props.touched[name] && props.errors[name]) && (
        <Typography color="error" variant="body2">
          {props.errors[name]}
        </Typography>
      )}
    </Fragment>
  );
};

export default Check;
